import { useContext } from 'react'
import { appBarContext } from '../AppBar/AppBarContextProvider'
import { Toolbar, Typography, IconButton } from '@mui/material'
import useStyles from './mainNavigationStyles'
import { CloseRounded as IconCloseRounded } from '@mui/icons-material'

const MainNavigationToolbar = () => {
  const { toolBar, iconButtonClose } = useStyles()
  const { handleCloseLeftDrawer } = useContext(appBarContext)

  return (
    <Toolbar className={toolBar} variant="dense" disableGutters>
      <IconButton
        color="primary"
        size="small"
        aria-label="Sluit het hoofdmenu"
        onClick={handleCloseLeftDrawer}
        className={iconButtonClose}
      >
        <IconCloseRounded />
      </IconButton>
      <Typography component="span" variant="h5">
        Hoofdmenu
      </Typography>
    </Toolbar>
  )
}

export default MainNavigationToolbar
